import Icon from './Icon'
import Video from './Video'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class PlaylistHighlightStory extends Component {
  static propTypes = {
    isPlaying: PropTypes.bool.isRequired,
    onEnded: PropTypes.func.isRequired,
    onPlay: PropTypes.func.isRequired,
    playlist: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)

    this.handleEnded = this.handleEnded.bind(this)

    this.state = {
      focusedClip: props.playlist.playlistClips[0]
    }
  }

  componentDidUpdate(_, { focusedClip }) {
    if (focusedClip !== this.state.focusedClip && this.video) {
      this.video.currentTime(0)
      this.video.play()
    }
  }

  isFinalized() {
    const { playlist } = this.props
    return playlist.publishVideo && !playlist.publishDirtyFl
  }

  handleEnded() {
    const { onEnded, playlist } = this.props
    const { focusedClip } = this.state
    const { playlistClips } = playlist
    const clipIndex = playlistClips.indexOf(focusedClip)

    if (this.isFinalized()) {
      onEnded()
    } else if (clipIndex === playlistClips.length - 1) {
      onEnded()
      this.setState({ focusedClip: playlistClips[0] })
    } else {
      this.setState({ focusedClip: playlistClips[clipIndex + 1] })
    }
  }

  getSrc() {
    const { playlist } = this.props
    const { focusedClip } = this.state

    if (this.isFinalized()) {
      return playlist.publishVideo.src
    }

    return focusedClip.video.src
  }

  getPlugins() {
    const { focusedClip } = this.state

    if (this.isFinalized()) {
      return {}
    }

    return {
      clip: {
        startTime: focusedClip.startTime,
        endTime: focusedClip.endTime,
        restrictPlaybackToClip: true
      }
    }
  }

  render() {
    const { isPlaying, onPlay, playlist } = this.props

    return (
      <div className="insight-story-ng-controller">
        {!isPlaying && (
          <div
            className="image-container"
            style={{ backgroundImage: `url(${playlist.image.large})` }}
            onClick={onPlay}
          >
            <Icon name="play" />
          </div>
        )}
        {isPlaying && playlist.playlistClips.length > 0 && (
          <Video
            ref={video => {
              this.video = video
            }}
            src={this.getSrc()}
            height="100%"
            listeners={{ ended: this.handleEnded }}
            options={{ autoplay: true }}
            plugins={this.getPlugins()}
            controlBar={{ volumeControl: false }}
          />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/PlaylistHighlightStory.js